import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../../ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../../Util/axiosErrorHandler'
import { APIPerson, Person } from '../IPerson'
import { personTransform } from '../transformer/personTransformer'

export const fetchPersonList = createAsyncThunk<
  Person[],
  { establishmentId: number },
  IThunkReject<any>
>('personList/fetch', async (payload, { rejectWithValue }) => {
  let apiData: APIPerson[] | null = null

  try {
    const promise = clientSDK
      .instance()
      .get<APIPerson[]>(`persons?establishment_id=${payload.establishmentId}`)

    const result = await promise
    apiData = result.data
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return apiData.map(data => personTransform(data))
})
